module.exports = __webpack_public_path__ + "static/media/2022__K8A0333.8b0cb954.jpg";